<template>
  <div class="caseLogo">
    <div class="mid-box">
      <div class="show-pc title">超万户纳税人验证的专业税务SaaS平台</div>
      <div class="show-h5 introduction_title">
        <span class="text"
          >超万户纳税人验证的
          <div class="title_h5_icon">
            <hm-img
              imgName="home_service_icon_06_h5_zh"
              imgClass="module_img_style"
            />
          </div>
        </span>
        <div class="text2">专业税务SaaS平台</div>
      </div>
      <div class="">
        <vue-seamless-scroll :data="list1" :class-option="optionLeft" class="seamless-warp2">
          <div class="scroll-box">
            <div class="case-logo-content">
              <div
                class="case-logo-content-item"
                v-for="(item, index) in list1"
                :key="index"
              >
                <hm-img
                  type="images/banner/company-logo"
                  :imgName="isH5?item.icon_H5:item.icon"
                  imgClass="icon-img"
                />
              </div>
            </div>
          </div>
        </vue-seamless-scroll>
        <vue-seamless-scroll :data="list2" :class-option="optionLeft1" class="seamless-warp2">
          <div class="scroll-box">
            <div class="case-logo-content">
              <div
                class="case-logo-content-item"
                v-for="(item, index) in list2"
                :key="index"
              >
                <hm-img
                  type="images/banner/company-logo"
                  :imgName="isH5?item.icon_H5:item.icon"
                  imgClass="icon-img"
                />
              </div>
            </div>
          </div>
        </vue-seamless-scroll>
        <vue-seamless-scroll :data="list3" :class-option="optionLeft2" class="seamless-warp2">
          <div class="scroll-box">
            <div class="case-logo-content">
              <div
                class="case-logo-content-item"
                v-for="(item, index) in list3"
                :key="index"
              >
                <hm-img
                  type="images/banner/company-logo"
                  :imgName="isH5?item.icon_H5:item.icon"
                  imgClass="icon-img"
                />
              </div>
            </div>
          </div>
        </vue-seamless-scroll>
        <vue-seamless-scroll :data="list4" :class-option="optionLeft3" class="seamless-warp2">
          <div class="scroll-box">
            <div class="case-logo-content">
              <div
                class="case-logo-content-item"
                v-for="(item, index) in list4"
                :key="index"
              >
                <hm-img
                  type="images/banner/company-logo"
                  :imgName="isH5?item.icon_H5:item.icon"
                  imgClass="icon-img"
                />
              </div>
            </div>
          </div>
        </vue-seamless-scroll>
      </div>
      <!-- <div class="show-h5">
        <div class="case-logo-content">
          <div class="case-logo-h5" v-for="(h5, h) in list2" :key="h">
            <hm-img type="icons" :imgName="h5.icon" imgClass="h5" />
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
// !!MARK 目前用一张图片替代, 后期每个logo会有交互, 再启用
// import vueSeamless from "vue-seamless-scroll";
import { mapGetters } from 'vuex'
// const list = [
//   {
//     key: 1,
//     title: '制造业',
//     bgImg: require('../../../assets/images/home_case_01_zh.png')
//   },
//   {
//     key: 2,
//     icon: 'JFKJ',
//     iconClass: 'icon-02'
//   },
//   {
//     key: 3,
//     icon: 'AGG',
//     iconClass: 'icon-03'
//   },
//   {
//     key: 4,
//     icon: 'YKK',
//     iconClass: 'icon-04'
//   },
//   {
//     key: 5,
//     icon: 'BYD2',
//     iconClass: 'icon-05'
//   },
//   {
//     key: 6,
//     icon: 'RY',
//     iconClass: 'icon-letters'
//   },
//   {
//     key: 7,
//     icon: 'HG',
//     iconClass: 'icon-07'
//   },
//   {
//     key: 8,
//     icon: 'MSJ',
//     iconClass: 'icon-08'
//   },
//   {
//     key: 9,
//     title: '生物医疗',
//     subtitle: '跨境电商',
//     bgImg: require('../../../assets/images/home_case_02_zh.png')
//   },
//   {
//     key: 10,
//     icon: 'YF',
//     iconClass: 'icon-10'
//   },
//   {
//     key: 11,
//     icon: 'WXSW',
//     iconClass: 'icon-11'
//   },

//   {
//     key: 24,
//     icon: 'DMHXM',
//     iconClass: 'icon-24'
//   },
//   {
//     key: 25,
//     title: '物流运输',
//     bgImg: require('../../../assets/images/home_case_04_zh.png')
//   },
//   {
//     key: 26,
//     icon: 'HXCX',
//     iconClass: 'icon-26'
//   },
//   {
//     key: 27,
//     icon: 'OI',
//     iconClass: 'icon-27'
//   },
//   {
//     key: 28,
//     icon: 'HLL',
//     iconClass: 'icon-letters'
//   },
//   {
//     key: 29,
//     icon: 'SF',
//     iconClass: 'icon-letters'
//   },
//   {
//     key: 30,
//     icon: 'HDKGJ',
//     iconClass: 'icon-30'
//   },
//   {
//     key: 31,
//     icon: 'ZQ',
//     iconClass: 'icon-31'
//   },
//   {
//     key: 32,
//     icon: 'HZX',
//     iconClass: 'icon-32'
//   },
//   {
//     key: 33,
//     title: '能源 金融 地产',
//     bgImg: require('../../../assets/images/home_case_05_zh.png')
//   },
//   {
//     key: 34,
//     icon: 'DYZYH',
//     iconClass: 'icon-34'
//   },
//   {
//     key: 35,
//     icon: 'FYTKLSL',
//     iconClass: 'icon-35'
//   },
//   {
//     key: 36,
//     icon: 'QMZB',
//     iconClass: 'icon-36'
//   },
//   {
//     key: 37,
//     icon: 'CHNENERGY',
//     iconClass: 'icon-37'
//   },
//   {
//     key: 38,
//     icon: 'Chelion',
//     iconClass: 'icon-38'
//   },
//   {
//     key: 39,
//     icon: 'QXJT',
//     iconClass: 'icon-39'
//   },
//   {
//     key: 40,
//     icon: 'ZGGF',
//     iconClass: 'icon-40'
//   },
//   {
//     key: 41,
//     title: '服务 综合',
//     subtitle: '互联网平台',
//     bgImg: require('../../../assets/images/home_case_06_zh.png')
//   },
//   {
//     key: 42,
//     icon: 'TXZW',
//     iconClass: 'icon-42'
//   },
//   {
//     key: 43,
//     icon: 'WS',
//     iconClass: 'icon-43'
//   },
//   {
//     key: 44,
//     icon: 'AG',
//     iconClass: 'icon-44'
//   },
//   {
//     key: 45,
//     icon: 'ZKZS',
//     iconClass: 'icon-45'
//   },
//   {
//     key: 46,
//     icon: 'LG',
//     iconClass: 'icon-46'
//   },
//   {
//     key: 47,
//     icon: 'GHKJ',
//     iconClass: 'icon-47'
//   },
//   {
//     key: 48,
//     icon: 'JZQY',
//     iconClass: 'icon-48'
//   }
// ]
const list1 = [
  {
    key: 1,
    icon: 'MDE',
    icon_H5: 'MDE_H5',
    iconClass: 'icon-1'
  },
  {
    key: 2,
    icon: 'PN',
    icon_H5: 'PN_H5',
    iconClass: 'icon-2'
  },
  {
    key: 3,
    icon: 'LG',
    icon_H5: 'LG_H5',
    iconClass: 'icon-3'
  },
  {
    key: 4,
    icon: 'WJ',
    icon_H5: 'WJ_H5',
    iconClass: 'icon-4'
  },
  {
    key: 5,
    icon: 'DM',
    icon_H5: 'DM_H5',
    iconClass: 'icon-5'
  },
  {
    key: 6,
    icon: 'AN',
    icon_H5: 'AN_H5',
    iconClass: 'icon-5'
  },
  {
    key: 7,
    icon: 'YN',
    icon_H5: 'YN_H5',
    iconClass: 'icon-6'
  },
  {
    key: 8,
    icon: 'HT',
    icon_H5: 'HT_H5',
    iconClass: 'icon-5'
  },
  {
    key: 9,
    icon: 'MS',
    icon_H5: 'MS_H5',
    iconClass: 'icon-5'
  },
  {
    key: 10,
    icon: 'EF',
    icon_H5: 'EF_H5',
    iconClass: 'icon-6'
  },
  {
    key: 11,
    icon: 'HTM',
    icon_H5: 'HTM_H5',
    iconClass: 'icon-5'
  },
  {
    key: 12,
    icon: 'SP',
    icon_H5: 'SP_H5',
    iconClass: 'icon-5'
  },
  {
    key: 13,
    icon: 'QX',
    icon_H5: 'QX_H5',
    iconClass: 'icon-6'
  },
  {
    key: 14,
    icon: 'CH',
    icon_H5: 'CH_H5',
    iconClass: 'icon-6'
  },
  {
    key: 15,
    icon: 'Mips',
    icon_H5: 'Mips_H5',
    iconClass: 'icon-6'
  },
  {
    key: 16,
    icon: 'KF',
    icon_H5: 'KF_H5',
    iconClass: 'icon-6'
  },
  {
    key: 17,
    icon: 'YJSCY',
    icon_H5: 'YJSCY_H5',
    iconClass: 'icon-6'
  },
  {
    key: 18,
    icon: 'HS',
    icon_H5: 'HS_H5',
    iconClass: 'icon-6'
  },
  {
    key: 19,
    icon: 'JHJQR',
    icon_H5: 'JHJQR_H5',
    iconClass: 'icon-6'
  }
]
const list2 = [
  {
    key: 1,
    icon_H5: 'EG_H5',
    icon: 'EG'
  },
  {
    key: 2,
    icon_H5: 'ZW_H5',
    icon: 'ZW'
  },
  {
    key: 3,
    icon_H5: 'COMIX_H5',
    icon: 'COMIX'
  },
  {
    key: 4,
    icon_H5: 'YF_H5',
    icon: 'YF'
  },
  {
    key: 5,
    icon: 'JF',
    icon_H5: 'JF_H5'
  },
  {
    key: 6,
    icon: 'YKK',
    icon_H5: 'YKK_H5'
  },
  {
    key: 7,
    icon: 'GN',
    icon_H5: 'GN_H5'
  },
  {
    key: 8,
    icon: 'BYD',
    icon_H5: 'BYD_H5'
  },
  {
    key: 9,
    icon: 'SHOKZ',
    icon_H5: 'SHOKZ_H5'
  },
  {
    key: 10,
    icon: 'MGI',
    icon_H5: 'MGI_H5'
  },
  {
    key: 11,
    icon: 'HPLS',
    icon_H5: 'HPLS_H5'
  },
  {
    key: 12,
    icon: 'Chelion',
    icon_H5: 'Chelion_H5'
  },
  {
    key: 13,
    icon: 'JN',
    icon_H5: 'JN_H5'
  },
  {
    key: 14,
    icon: 'HDKG',
    icon_H5: 'HDKG_H5'
  },
  {
    key: 15,
    icon: 'MHB',
    icon_H5: 'MHB_H5'
  },
  {
    key: 16,
    icon: 'Tims',
    icon_H5: 'Tims_H5'
  },
  {
    key: 17,
    icon: 'AMT',
    icon_H5: 'AMT_H5'
  },
  {
    key: 18,
    icon: 'MLDJ',
    icon_H5: 'MLDJ_H5'
  },
  {
    key: 19,
    icon: 'THFZ',
    icon_H5: 'THFZ_H5'
  }
]
const list3 = [
{
    key: 1,
    icon: 'JZQY',
    icon_H5: 'JZQY_H5'
  },
  {
    key: 2,
    icon: 'CZ',
    icon_H5: 'CZ_H5'
  },
  {
    key: 3,
    icon: 'MD',
    icon_H5: 'MD_H5'
  },
  {
    key: 4,
    icon: 'HTFJJ',
    icon_H5: 'HTFJJ_H5'
  },
  {
    key: 5,
    icon: 'ZHS',
    icon_H5: 'ZHS_H5'
  },
  {
    key: 6,
    icon: 'TFHJ',
    icon_H5: 'TFHJ_H5'
  },
  {
    key: 7,
    icon: 'COSTA',
    icon_H5: 'COSTA_H5'
  },
  {
    key: 8,
    icon: 'RP',
    icon_H5: 'RP_H5'
  },
  {
    key: 9,
    icon: 'MXLD',
    icon_H5: 'MXLD_H5'
  },
  {
    key: 10,
    icon: 'PU',
    icon_H5: 'PU_H5'
  },
  {
    key: 11,
    icon: 'DST',
    icon_H5: 'DST_H5'
  },
  {
    key: 12,
    icon: 'ZG',
    icon_H5: 'ZG_H5'
  },
  {
    key: 13,
    icon: 'ZJKG',
    icon_H5: 'ZJKG_H5'
  },
  {
    key: 14,
    icon: 'BC',
    icon_H5: 'BC_H5'
  },
  {
    key: 15,
    icon: 'SS',
    icon_H5: 'SS_H5'
  },
  {
    key: 16,
    icon: 'BWCJ',
    icon_H5: 'BWCJ_H5'
  },
  {
    key: 17,
    icon: 'JMJ',
    icon_H5: 'JMJ_H5'
  },
  {
    key: 18,
    icon: 'YDDL',
    icon_H5: 'YDDL_H5'
  },
  {
    key: 19,
    icon: 'ZLF',
    icon_H5: 'ZLF_H5'
  }
]
const list4 = [
  {
    key: 1,
    icon: 'HLL',
    icon_H5: 'HLL_H5'
  },
  {
    key: 2,
    icon: 'CC',
    icon_H5: 'CC_H5'
  },
  {
    key: 3,
    icon: 'TX',
    icon_H5: 'TX_H5'
  },
  {
    key: 4,
    icon: 'STL',
    icon_H5: 'STL_H5'
  },
  {
    key: 5,
    icon: 'WEIS',
    icon_H5: 'WEIS_H5'
  },
  {
    key: 6,
    icon: 'AIRWALLEX',
    icon_H5: 'AIRWALLEX_H5'
  },
  {
    key: 7,
    icon: 'HXCX',
    icon_H5: 'HXCX_H5'
  },
  {
    key: 9,
    icon: 'DDMC',
    icon_H5: 'DDMC_H5'
  },
  {
    key: 10,
    icon: 'PARKSON',
    icon_H5: 'PARKSON_H5'
  },
  {
    key: 11,
    icon: 'AGC',
    icon_H5: 'AGC_H5'
  },
  {
    key: 12,
    icon: 'HA',
    icon_H5: 'HA_H5'
  },
  {
    key: 13,
    icon: 'JT',
    icon_H5: 'JT_H5'
  },
  {
    key: 14,
    icon: 'SF',
    icon_H5: 'SF_H5'
  },
  {
    key: 15,
    icon: 'YD',
    icon_H5: 'YD_H5'
  },
  {
    key: 16,
    icon: 'HRXH',
    icon_H5: 'HRXH_H5'
  },
  {
    key: 17,
    icon: 'wonderlab',
    icon_H5: 'wonderlab_H5'
  },
  {
    key: 18,
    icon: 'ZR',
    icon_H5: 'ZR_H5'
  }
]
export default {
  // components: {
  //   vueSeamless,
  // },
  computed: {
    ...mapGetters(['isH5']),
    optionLeft ({isH5}) {
      return {
        direction: 2,
        limitMoveNum: 12,
        step: isH5 ? 0.8 : 1
      }
    },
    optionLeft1 ({isH5}) {
      return {
        direction: 3,
        limitMoveNum: 14,
        step: isH5 ? 0.6 : 0.8
      }
    },
    optionLeft2 ({isH5}) {
      return {
        direction: 2,
        limitMoveNum: 13,
        step: isH5 ? 0.8 : 1
      }
    },
    optionLeft3 ({isH5}) {
      return {
        direction: 3,
        limitMoveNum: 13,
        step: isH5 ? 0.6 : 0.8
      }
    }
  },
  data () {
    return {
      headStyle: {
        backgroundImage:
          'url(' + require('@/assets/images/home_case_bg2_zh.png') + ')',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      },
      // list,
      list1,
      list2,
      list3,
      list4
    }
  }
}
</script>

<style lang="less" scoped>
#hm-web {
  .caseLogo {
    width: 100%;
    display: flex;
    justify-content: center;
    .mid-box {
      margin: 0 auto;
      padding-bottom: 80PX;
      .title{
        margin-bottom: 60PX;
        font-size: 36PX;
        color: #292F3A;
        text-align: center;
        line-height: 36PX;
        font-weight: 600;
      }
      .seamless-warp2 {
        overflow: hidden;
        width: 100%;
        height: 72PX;
        display: inline-block;
        margin-bottom: 16PX;
        .scroll-box{
          width: 100%;
        }
        .case-logo-content {
          display: flex;
          justify-content: space-between;
          &-item {
            background: #fff;
            width: 160PX;
            height: 72PX;
            border-radius: 6px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 24px;
            .item-title {
              font-size: 16px;
              color: #ffffff;
              text-align: center;
              font-weight: 600;
            }
            .icon-img{
              width: 160px;
              height: 72px;
            }
          }
          &-item:last-child {
            // margin-right: 0;
          }
        }
      }
    }
    .show-h5{
      .text,
      .text2{
        font-size: 20PX;
      }
    }
  }
  @media screen and (max-width: 1200px) {
    .caseLogo {
      height: 735px;
      background: #fff;
      background-image: url("~@/assets/images/home_case_bg2_zh_h5.png");
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      width: 100%;
      .mid-box {
        width: 100%;
        height: 100%;
        box-sizing: content-box;
        // padding-bottom: 56px;
        .seamless-warp2 {
          height: 80px;
          .case-logo-content {
            // margin-top: 60px;
            padding: 0;
            &-item{
              background-color: #f2f7fc;
              width: 160px;
              height: 80px;
              .icon-img{
                width: 160px;
                height: 80px;
              }
            }
            .case-logo-h5 {
              width: 160px;
              height: 80px;
              margin-bottom: 24px;
            }
          }
        }
      }
    }
    .introduction_title {
      padding-top: 60px;
      margin-bottom: 48px;
      text-align: center;
      .text {
        font-family: PingFangSC-Medium;
        font-size: 40px;
        color: #292f3a;
        letter-spacing: 2px;
        text-align: center;
        line-height: 60px;
        font-weight: 700;
        padding: 44px 0 60px;
        position: relative;
        .title_h5_icon {
          width: 32px;
          height: 32px;
          position: absolute;
          right: -1%;
          top: -2%;
          transform: translate(50%, 70%);
        }
      }
      .text2 {
        font-family: PingFangSC-Medium;
        font-size: 40px;
        color: #292f3a;
        letter-spacing: 0;
        text-align: center;
        line-height: 60px;
        font-weight: 700;
      }
    }
  }
  @media screen and (min-width: 1200px) {
    .caseLogo {
      height: 584PX;
      background-image: url("~@/assets/images/home_case_bg2_zh.png");
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      position: relative;
      &::before{
        content: '';
        width: 361PX;
        height: 100%;
        position: absolute;
        left: -155PX;
        top: 0;
        background-image: linear-gradient(269deg, rgba(224,240,255,0.00) 0%, #EAF5FF 50%, #E0F0FF 100%);
        // filter: blur(100px);
        z-index: 100;
      }
      &::after{
        content: '';
        width: 361PX;
        height: 100%;
        position: absolute;
        right: -155PX;
        top: 0;
        transform: scaleX(-1);
        background-image: linear-gradient(269deg, rgba(224,240,255,0.00) 0%, #EAF5FF 50%, #E0F0FF 100%);
        // filter: blur(100px);
        z-index: 10;
      }
      .mid-box {
        width: 100%;
        padding-top: 80px;
      }
      .title {
        font-size: 36px;
        color: #292f3a;
        text-align: center;
        line-height: 36px;
        font-weight: 600;
      }
      .case-logo-content {
        // margin-top: 60px;
      }
    }
  }
}
</style>
<style lang="less">
#hm-web {
  .icon-img{
    width: 160PX;
    height: 72PX;
    border-radius: 6PX;
  }
}
@media screen and (max-width: 1200px) {
  #hm-web {
    .icon-img{
      width: 160px;
      height: 80px;
      border-radius: 6px;
    }
    .module_img_style {
      width: 32px;
    }
}
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/caseLogo_old.vue